import React from "react";

const AddToCart = () => {
  return <div><h1 className="mx-auto">This is add to cart</h1></div>;
};

export default AddToCart;
